import React from 'react';
import Table from 'react-bootstrap/Table';
import { useSelector } from 'react-redux';

import { bankAccountTitles } from '../../constants/companies';
import { getCurrentCompany } from '../../store/selectors';
import { formatNumber } from '../../helpers/companiesHelper';

const bank =
  typeof bankAccountTitles.bank === 'string' && bankAccountTitles.bank;
const currency =
  typeof bankAccountTitles.currency === 'string' && bankAccountTitles.currency;
const balanceInCurrency =
  typeof bankAccountTitles.balance_in_currency === 'string' &&
  bankAccountTitles.balance_in_currency;

function BankTable() {
  const currentCompany = useSelector(getCurrentCompany) || {};
  const bankAccounts = currentCompany.bank_accounts;

  if (bankAccounts && bankAccounts.length > 0) {
    return (
      <div className="mb-4">
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>{bank}</th>
              <th>{currency}</th>
              <th>{balanceInCurrency}</th>
            </tr>
          </thead>
          <tbody>
            {bankAccounts.map((account) => (
              <tr key={account.account_number}>
                <td>{typeof account.bank === 'string' && account.bank}</td>
                <td>
                  {typeof account.currency === 'string' && account.currency}
                </td>
                <td>
                  {formatNumber(account.balance_in_currency)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default BankTable;
